import * as Sentry from '@sentry/react';

// When an order created by "Company A" and dispatched to "Company B" is tied to a site
// that is not visible to "Company B", the API will return a 404 when a user from the
// latter tries to fetch the site's additional geofences.
export function ignoreSiteAdditionalGeofences404Rule(event: Sentry.ErrorEvent) {
  const is404ErrorReponse = event.contexts?.response?.status_code === 404;
  const isGETRequest = event.request?.method === 'GET';

  const requestUrl = event.request?.url ?? '';
  const regexp = /v1\/companies\/(\w|-){36}\/sites\/(\w|-){36}\/additional_geofences$/;
  const isFetchingSiteAdditionalGeofences = regexp.test(requestUrl);

  return is404ErrorReponse && isGETRequest && isFetchingSiteAdditionalGeofences;
}
